import { Component, OnInit, ViewChild } from '@angular/core';
import { CompanyApi, OrderEmployeeApi, GiftsApi, UserApi, StoreApi, CertificateApi, CertificateCategoryApi, Employee, CampusApi, Gifts, LoopBackAuth, Campus, CertificateCategory } from '../../../services/shared/sdk';
import { MatTableDataSource, MatSort, MatPaginator, MatDialog } from '@angular/material';
import { InfoPedidoComponent } from '../info-pedido/info-pedido.component';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { registerLocaleData } from '@angular/common';
import * as momentTz from 'moment-timezone';

import localeEsMx from '@angular/common/locales/es-MX';
import { Moment } from 'moment';

export enum statusType {
  'available' = 'Entregado',
  'expired' = 'Expirado',
  'changed' = 'Usado',
  'dowloded' = 'Descargado',
  'pending' = 'Pendiente'
}

moment.locale('es-MX');

registerLocaleData(localeEsMx, 'es-MX');

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {

  hoveredDate: NgbDate | null = null;

  fromDate: any;
  toDate: any | null = null;
  fromDateReport: any
  toDateReport: any
  FechaActual = new Date();
  FechaAnterior = moment(this.FechaActual).subtract(15, "days");

  companies;
  stores;
  orders;
  certificados;
  companyId = 'all';
  status = 'all';
  storeId = 'all';
  certtype = "all";
  ordersCompany;
  ordersFiltered;
  dropdownSettings = {};
  dropdownSettings2 = {};
  campuses: Campus[];
  searchFrom: string;
  searchTo: string;
  certificateCategories: CertificateCategory[];

  dataOrders: MatTableDataSource<any> = new MatTableDataSource([]);
  @ViewChild(MatSort, { static: null }) sort: MatSort;

  @ViewChild('singlePaginator', { static: null }) paginator: MatPaginator;

  statusType = [
    "en revisión",
    "programado",
    "enviado",
    "canjeado",
    "por expirar",
    "expirado",
    "cancelado"
  ];
  displayedColumns = ["createdAt", "employeeName", "campusName", "storeName", "employeeEmail", "uploadedDate", "categories", "value", "status"];
  user: any;
  constructor(
    public dialog: MatDialog,
    private _company: CompanyApi,
    private _orders: OrderEmployeeApi,
    private _user: UserApi,
    private _gifts: GiftsApi,
    private _store: StoreApi,
    private _certificate: CertificateApi,
    private _certCategory: CertificateCategoryApi,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private _campus: CampusApi,
    private _auth: LoopBackAuth
  ) { }

  ngOnInit() {
    console.log(this._auth.getCurrentUserData());
    this.user = this._auth.getCurrentUserData();
    //this.getCompanies();
    this.getStores();
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      itemsShowLimit: 25,
      allowSearchFilter: true,
      searchPlaceholderText: 'Buscar empresa',
      closeDropDownOnSelection: true
    };
    this.dropdownSettings2 = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      itemsShowLimit: 25,
      allowSearchFilter: true,
      searchPlaceholderText: 'Buscar comercio',
      closeDropDownOnSelection: true
    };
    this._campus.find({ where: { companyId: this.user.companyId, isDeleted: false } }).subscribe((campuses: any) => {
      this.campuses = campuses
    })

    this.getCertCategories();
    const start = momentTz().tz('Mexico/General').startOf('day')
    const end = momentTz().tz('Mexico/General').endOf('day')
    this.fromDateReport = new Date()
    this.toDateReport = new Date()

    this.OrdenesPorFecha(start, end)
  }

  getCompanies() {
    this._company.find({ where: { isDeleted: false }, include: 'adminCompanies' }).subscribe((companies) => {
      this._user.getCurrent().subscribe((admin) => {
        if (admin.isSuperAdmin) {
          this.companies = companies;
          this.companies.unshift({ name: 'MOSTRAR TODO', id: 'all' });
        } else {
          this.companies = companies.filter((company: any) => {
            return company.adminCompanies.map((admin) => admin.adminId).includes(admin.id);
          });
          this.companies.unshift({ name: 'MOSTRAR TODO', id: 'all' });
        }
        //this.getGifts();
        this.getCertCategories();
        const start = momentTz().tz('Mexico/General').startOf('day')
        const end = momentTz().tz('Mexico/General').endOf('day')
        this.fromDateReport = new Date()
        this.toDateReport = new Date()

        this.OrdenesPorFecha(start, end)
      });
    })
  }

  getStores() {
    this._store.find({ where: { isDeleted: false }, include: 'companyStores' }).subscribe((stores: any) => {
      this._user.getCurrent().subscribe((admin) => {
        if (admin.isSuperAdmin) {
          this.stores = stores;
          this.stores.unshift({ name: 'MOSTRAR TODO', id: 'all' });
        } else {
          this.stores = stores.filter((sto: any) => {
            return sto.companyStores.map((company_store) => company_store.companyId).includes(this.user.companyId);
          });
          this.stores.unshift({ name: 'Mostrar todas', id: 'all' });
        }
      });
    })
  }

  getGifts() {
    this._gifts.getGifts({
      include: [{
        relation: 'employee',
        scope: {
          include: {
            relation: ['company', 'campus']
          }
        }
      }, {
        relation: 'certificate',
        scope: {
          include: {
            relation: 'certCategory'
          }
        }
      }, 'store']
    }).subscribe((gifts: any) => {
      console.log({ gifts });

      gifts.forEach(element => {
        if (element.employee) {
          element.employeeName = element.employee.name;
          element.employeeEmail = element.employee.email;

          if (element.employee.campusId) {
            element.campusName = this.campuses.find(c => c.id == element.employee.campusId)
          }
        }
        element.storeName = element.store.name;
        element.createdAt = moment(element.createdAt).format('DD/MM/YYYY hh:mm a')
        if (!element.uploadedDate) { element.uploadedDate = "Sin asignar" }
        else { element.uploadedDate = moment(element.uploadedDate).format('DD/MM/YYYY hh:mm a') }

        if (element.status == 'available') { element.status = 'Entregado' }
        else if (element.status == 'expired') { element.status = 'Expirado' }
        else if (element.status == 'changed') { element.status == 'Usado' }
        else { element.status = 'Pendiente' }
        //element.status == 'available' ? 'Entregado' : element.status == 'expired' ? 'Expirado' : element.status == 'changed' ? 'Usado' : 'Pendiente'
      });

      this.orders = gifts.filter((gift) => this.companies.map((company) => company.id).includes(gift.companyId)).reverse();
      console.log(this.orders);

      this.dataOrders = new MatTableDataSource(this.orders);
      this.dataOrders.sort = this.sort;
      setTimeout(() => this.dataOrders.paginator = this.paginator);
    })
  }

  getCertCategories() { //Funcion para traer las categorias de los certificados
    this._certCategory.find({ where: { isDeleted: false } }).subscribe((resp: CertificateCategory[]) => {
      this.certificateCategories = resp;
      console.log(resp);

      let ArregloNombres = [];
      let certs = resp.filter((cert: any) => { //Filtrado de certificados, unicamente los que pertenecen a las compañías activas
        return this.user.companyId == cert.companyId;
      })
      certs.forEach((element: any) => { //Llenado de arreglo con los nombres
        ArregloNombres.push(element.name);
      });
      this.certificados = Array.from(new Set(ArregloNombres)); //Filtrado del arreglo de nombres, dejando sin repetidos para el select
    })
  }

  filterCert(event) {
    this.certtype = event.target.value;
    this.ordersFiltered = [];

    if (this.companyId != 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.employee) {
          if (order.status == this.status && order.employee.company.id == this.companyId && order.store.id == this.storeId && order.categories[0] == this.certtype) {
            this.ordersFiltered.push(order);
          }
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status && order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.store.id == this.storeId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.status == this.status && order.store.id == this.storeId && order.categories[0] == this.certtype)) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.status == this.status && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if (order.status == this.status) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.store.id == this.storeId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if (order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else {
      this.ordersFiltered = this.orders;
    }

    this.dataOrders = new MatTableDataSource(this.ordersFiltered);
    setTimeout(() => this.dataOrders.paginator = this.paginator);
  }

  selectCompany(event) {
    this.ordersFiltered = [];
    this.companyId = event.id;
    if (this.companyId != 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.employee) {
          if (order.status == this.status && order.employee.company.id == this.companyId && order.store.id == this.storeId && order.categories[0] == this.certtype) {
            this.ordersFiltered.push(order);
          }
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status && order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.store.id == this.storeId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.status == this.status && order.store.id == this.storeId && order.categories[0] == this.certtype)) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.status == this.status && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if (order.status == this.status) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.store.id == this.storeId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if (order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else {
      this.ordersFiltered = this.orders;
    }

    this.dataOrders = new MatTableDataSource(this.ordersFiltered);
    setTimeout(() => this.dataOrders.paginator = this.paginator);
  }

  selectStore(event) {
    this.ordersFiltered = [];
    this.storeId = event.id;

    if (this.companyId != 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.employee) {
          if (order.status == this.status && order.employee.company.id == this.companyId && order.store.id == this.storeId && order.categories[0] == this.certtype) {
            this.ordersFiltered.push(order);
          }
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status && order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.store.id == this.storeId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.status == this.status && order.store.id == this.storeId && order.categories[0] == this.certtype)) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.status == this.status && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if (order.status == this.status) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.store.id == this.storeId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if (order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else {
      this.ordersFiltered = this.orders;
    }

    this.dataOrders = new MatTableDataSource(this.ordersFiltered);
    setTimeout(() => this.dataOrders.paginator = this.paginator);
  }

  filterType(event) {
    this.status = event.target.value;
    return this.applyFilter(this.status == 'all' ? '' : this.status)/*
    return this.dataOrders.data = this.status == 'all' ? this.orders : this.dataOrders.filteredData.filter(order => order.status == this.status)

    this.ordersFiltered = [];
    if (this.companyId != 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.employee) {
          if (order.status == this.status && order.employee.company.id == this.companyId && order.store.id == this.storeId && order.categories[0] == this.certtype) {
            this.ordersFiltered.push(order);
          }
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status && order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.status == this.status) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.store.id == this.storeId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId != 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if ((order.employee && order.employee.company) && order.employee.company.id == this.companyId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if ((order.status == this.status && order.store.id == this.storeId && order.categories[0] == this.certtype)) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.status == this.status && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status != 'all' && this.storeId == 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if (order.status == this.status) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.store.id == this.storeId && order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId != 'all' && this.certtype == "all") {
      this.orders.forEach((order: any) => {
        if (order.store.id == this.storeId) {
          this.ordersFiltered.push(order);
        }
      });
    }

    else if (this.companyId == 'all' && this.status == 'all' && this.storeId == 'all' && this.certtype != "all") {
      this.orders.forEach((order: any) => {
        if (order.categories[0] == this.certtype) {
          this.ordersFiltered.push(order);
        }
      });
    }
    else {
      this.ordersFiltered = this.orders;
    }

    this.dataOrders = new MatTableDataSource(this.ordersFiltered);
    setTimeout(() => this.dataOrders.paginator = this.paginator);*/
  }

  // create(){  // Generar pedidos de prueba hardcodeados
  //   this._orders.create({employeeId:9,companyId:7, status:'en revisión', createdAt: new Date(), amount: 3000}).subscribe(orden => {
  //     console.log(`La orden fue creada ${orden}`);
  //     this.getGifts();
  //   })
  // }

  applyFilter(filterValue: string) {
    this.dataOrders.filter = filterValue.trim().toLowerCase();

    if (this.dataOrders.paginator) {
      this.dataOrders.paginator.firstPage();
    }
  }

  OpenInfo(order) {
    const InforOrder = this.dialog.open(InfoPedidoComponent, {
      width: '50%',
      data: order
    });
  }

  onDateSelection(date?: NgbDate) {
    if (
      !this.fromDate &&
      !this.toDate
    ) {
      this.fromDate = date;
      this.fromDateReport = date
    } else if (
      this.fromDate &&
      !this.toDate &&
      date &&
      date.after(this.fromDate)
    ) {
      this.toDate = date;
      this.toDateReport = date
      const start = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`
      const end = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`

      let FechaAnt = momentTz(start).tz('Mexico/General').startOf('day')
      let FechaAct = momentTz(end).tz('Mexico/General').endOf('day')

      this.OrdenesPorFecha(FechaAnt, FechaAct);
    }
    else if (
      this.fromDate &&
      !this.toDate &&
      date &&
      this.fromDate == date
    ) {
      const start = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`
      const end = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`

      let FechaAnt = momentTz(start).tz('Mexico/General').startOf('day')
      let FechaAct = momentTz(end).tz('Mexico/General').endOf('day')

      this.OrdenesPorFecha(FechaAnt, FechaAct)
    }
    else if (
      this.fromDate &&
      this.toDate
    ) {
      const start = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`
      const end = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`

      let FechaAnt = momentTz(start).tz('Mexico/General').startOf('day')
      let FechaAct = momentTz(end).tz('Mexico/General').endOf('day')

      this.OrdenesPorFecha(FechaAnt, FechaAct)
    }
    else {
      this.toDate = null;
      this.fromDate = date;
      this.toDateReport = null;
      this.fromDateReport = date;
    }

  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  OrdenesPorFecha(FechaAnterior: Moment, FechaActual: Moment) {
    this.searchFrom = FechaAnterior.format('LL')
    this.searchTo = FechaActual.format('LL')
    const from = FechaAnterior.toISOString()
    const to = FechaActual.toISOString()
    this.orders = []

    this._gifts.getGifts({
      where: {
        createdAt: {
          between: [from, to]
        },
        companyId: this.user.companyId
      },
      include: [{
        relation: 'employee',
        scope: {
          include: {
            relation: 'company'
          }
        }
      }, 'store']
    }).subscribe((gifts: any[]) => {
      let tableData = [];
      console.log({ gifts });
      gifts = gifts.filter(gift => this.certificados.find(category => gift.categories.includes(category)));
      gifts.forEach(gift => {
        let element: any = { ...gift };

        /*if (gift.certs && gift.certs.length > 0) {
          element.categories = [];
          gift.certs.forEach(Cert => {
            this._certificate.findById(Cert, { include: 'category' }).subscribe((cert: any) => {
              element.categories.push(cert.category.name)
            })
          });
        }*/
        if (gift.employee) {
          element.employeeName = gift.employee.name;
          element.employeeEmail = gift.employee.email;
          if (element.employee.campusId) {
            // console.log(element.employee);
            // console.log(this.campuses);
            const campus = this.campuses.find(c => c.id == element.employee.campusId);
            element.campusName = campus ? campus.name : '';

          }
        }
        element.storeName = gift.store.name;
        element.createdAt = moment(gift.createdAt).format('DD/MM/YYYY hh:mm a')
        if (!gift.uploadedDate) { element.uploadedDate = "Sin asignar" }
        else { element.uploadedDate = moment(gift.uploadedDate).format('DD/MM/YYYY hh:mm a') }

        element.status =
          gift.status
            && gift.downloadHistory
            && gift.downloadHistory.length
            ? 'Descargado'
            : gift.status != null
              && statusType[gift.status]
              ? statusType[gift.status]
              : statusType.pending

        tableData = tableData.concat(element)
      });
      this.orders = tableData;
      console.log(this.orders);
      this.dataOrders.data = this.orders;
      this.dataOrders.sort = this.sort;
      setTimeout(() => this.dataOrders.paginator = this.paginator);
      this.fromDate = null
      this.toDate = null
    })
  }

  descargarReporte() {

    if (this.companyId != 'all' || this.status != 'all' || this.storeId != 'all' || this.certtype != 'all') {
      if (this.fromDateReport && this.toDateReport) {
        let fechaAnterior = moment(this.fromDateReport).subtract(1, 'month');
        let fechaActual = moment(this.toDateReport).subtract(1, 'month');
        let data: any = [
          {
            title: 'Reporte de pedidos de colaboradores. Del ' + fechaAnterior.format('DD/MM/YYYY') + ' al ' + fechaActual.format('DD/MM/YYYY'),
            fecha: 'Fecha: ' + moment(new Date()).format('DD/MM/YYYY hh:mm a')
          },
          {
            fecha: 'FECHA DEL PEDIDO',
            name: 'NOMBRE',
            campus: 'CAMPUS',
            email: 'EMAIL',
            status: 'ESTADO DEL PEDIDO',
            comercio: 'COMERCIO',
            entrega: 'FECHA DE ENTREGA',
            certificado: 'CERTIFICADO',
            value: 'MONTO'

          }
        ];
        this.ordersFiltered.forEach(element => {
          const campus = this.campuses.find((camp: any) => camp.id == element.employee.campusId)

          let order = {
            fecha: element.createdAt,
            name: element.employeeName,
            campusId: campus ? campus.name : '',
            email: element.employeeEmail,
            status: element.status,
            comercio: element.store.name,
            entrega: element.updatedAt ? moment(element.updatedAt).format('DD/MM/YYYY hh:mm a') : 'Sin asignar',
            certificado: element.categories[0],
            value: element.value
          }
          data.push(order);
        });
        const archivo = new Angular5Csv(data, 'Reporte de pedidos de colaboradores. Del ' + fechaAnterior.format('DD/MM/YYYY') + ' al ' + fechaActual.format('DD/MM/YYYY'));
      }
      else {
        if (this.fromDateReport && this.toDateReport) {
          let fechaAnterior = moment(this.fromDateReport).subtract(1, 'month');
          let fechaActual = moment(this.toDateReport).subtract(1, 'month');
          let data: any = [
            {
              title: 'Reporte de pedidos de colaboradores. Del ' + fechaAnterior.format('DD/MM/YYYY') + ' al ' + fechaActual.format('DD/MM/YYYY'),
              fecha: 'Fecha: ' + moment(new Date()).format('DD/MM/YYYY hh:mm a')
            },
            {
              fecha: 'FECHA DEL PEDIDO',
              name: 'NOMBRE',
              campus: 'CAMPUS',
              email: 'EMAIL',
              status: 'ESTADO DEL PEDIDO',
              comercio: 'COMERCIO',
              entrega: 'FECHA DE ENTREGA',
              certificado: 'CERTIFICADO',
              value: 'MONTO'
            }
          ];
          this.ordersFiltered.forEach(element => {
            const campus = this.campuses.find((camp: any) => camp.id == element.employee.campusId)

            let order = {
              fecha: element.createdAt,
              name: element.employeeName,
              campusId: campus ? campus.name : '',
              email: element.employeeEmail,
              status: element.status,
              comercio: element.store.name,
              entrega: element.updatedAt ? moment(element.updatedAt).format('DD/MM/YYYY hh:mm a') : 'Sin asignar',
              certificado: element.categories[0],
              value: element.value
            }
            data.push(order);
          });
          const archivo = new Angular5Csv(data, 'Reporte de pedidos de colaboradores. Del ' + fechaAnterior.format('DD/MM/YYYY') + ' al ' + fechaActual.format('DD/MM/YYYY'));
        }
      }
    }
    else {
      if (this.fromDateReport && this.toDateReport) {
        let fechaAnterior = moment(this.fromDateReport).subtract(1, 'month');
        let fechaActual = moment(this.toDateReport).subtract(1, 'month');
        let data: any = [
          {
            title: 'Reporte de pedidos de colaboradores. Del ' + fechaAnterior.format('DD/MM/YYYY') + ' al ' + fechaActual.format('DD/MM/YYYY'),
            fecha: 'Fecha: ' + moment(new Date()).format('DD/MM/YYYY hh:mm a')
          },
          {
            fecha: 'FECHA DEL PEDIDO',
            name: 'NOMBRE',
            campus: 'CAMPUS',
            email: 'EMAIL',
            status: 'ESTADO DEL PEDIDO',
            comercio: 'COMERCIO',
            entrega: 'FECHA DE ENTREGA',
            certificado: 'CERTIFICADO',
            value: 'MONTO'
          }
        ];
        this.orders.forEach(element => {
          const campus = this.campuses.find((camp: any) => camp.id == element.employee.campusId)

          let order = {
            fecha: element.createdAt,
            name: element.employeeName,
            campusId: campus ? campus.name : '',
            email: element.employeeEmail,
            status: element.status,
            comercio: element.store.name,
            entrega: element.updatedAt ? moment(element.updatedAt).format('DD/MM/YYYY hh:mm a ') : 'Sin asignar',
            certificado: element.categories[0],
            value: element.value
          }
          data.push(order);
        });
        const archivo = new Angular5Csv(data, 'Reporte de pedidos de colaboradores. Del ' + fechaAnterior.format('DD/MM/YYYY') + ' al ' + fechaActual.format('DD/MM/YYYY'));
      }
      else {
        if (this.fromDateReport && this.toDateReport) {
          let fechaAnterior = moment(this.fromDateReport).subtract(1, 'month');
          let fechaActual = moment(this.toDateReport).subtract(1, 'month');
          let data: any = [
            {
              title: 'Reporte de pedidos de colaboradores. Del ' + fechaAnterior.format('DD/MM/YYYY') + ' al ' + fechaActual.format('DD/MM/YYYY'),
              fecha: 'Fecha: ' + moment(new Date()).format('DD/MM/YYYY hh:mm a')
            },
            {
              fecha: 'FECHA DEL PEDIDO',
              name: 'NOMBRE',
              campus: 'CAMPUS',
              email: 'EMAIL',
              status: 'ESTADO DEL PEDIDO',
              comercio: 'COMERCIO',
              entrega: 'FECHA DE ENTREGA',
              certificado: 'CERTIFICADO',
              value: 'MONTO'
            }
          ];
          this.orders.forEach(element => {
            const campus = this.campuses.find((camp: any) => camp.id == element.employee.campusId)

            let order = {
              fecha: element.createdAt,
              name: element.employeeName,
              campusId: campus.name,
              email: element.employeeEmail,
              status: element.status,
              comercio: element.store.name,
              entrega: element.updatedAt ? moment(element.updatedAt).format('DD/MM/YYYY hh:mm a') : 'Sin asignar',
              certificado: element.categories[0],
              value: element.value
            }
            data.push(order);
          });
          const archivo = new Angular5Csv(data, 'Reporte de pedidos de colaboradores. Del ' + fechaAnterior.format('DD/MM/YYYY') + ' al ' + fechaActual.format('DD/MM/YYYY'));
        }
      }
    }
  }

}
